import { IParentChildWorkflowInfo, IParentChildHistory, IChildWorkflowHistory, IParentChildJourney } from './parentchild-workflow-info.types'
import { IHistory, IJourney, IWorkFlowStatusInfo, IWorkflowAction } from './workflow-info.types'
import { WorkflowAction, Journey, History,  WorkFlowStatusInfo } from './workflow-info'
import { IWorkflowData } from './workflow-data.types'

/** class for Workflow info */
export class ParentChildWorkflowInfo implements IParentChildWorkflowInfo {

    Journey: Array<ParentChildJourney>
    LogStatus: Array<ParentChildHistory>
    ActionItems: Array<WorkflowAction>
    CurrentStep: IWorkFlowStatusInfo

    constructor (data: IParentChildWorkflowInfo) {    
        this.Journey = data.Journey;
        this.LogStatus = data.LogStatus;
        this.ActionItems = data.ActionItems;
        this.CurrentStep = data.CurrentStep;
    }
}

export class ParentChildJourney extends Journey implements IParentChildJourney {
    WorkflowData: IWorkflowData
    ChildSteps: Array<IParentChildJourney>

    constructor (data: IParentChildJourney) {  
        super(data);  
        this.WorkflowData = data.WorkflowData;
        this.ChildSteps = data.ChildSteps;
    }
}


export class ParentChildHistory extends History implements IParentChildHistory {
    HistoryId: string
    ChildData: string
    ChildWorkflowHistory: Array<ChildHistory>

    constructor (data: IParentChildHistory) {  
        super(data);  
        this.HistoryId = data.HistoryId;
        this.ChildData = data.ChildData;
        this.ChildWorkflowHistory = data.ChildWorkflowHistory
    }
}

export class ChildHistory extends ParentChildHistory implements IChildWorkflowHistory {
    ChildStepId: string

    constructor (data: IChildWorkflowHistory) {  
        super(data);  
        this.ChildStepId = data.ChildStepId;
    }
}